// Node
const $ = require('jquery');
require('jquery.cookie');
require('inputmask');

// Custom
import moment from 'moment';
import FunnySadDialog from 'new_design/common/funny-sad-dialog';

class CallbackWidget {
  static ACTIVE_CONTENT_CLASS = 'call-back-popup__content--active';
  static CONTENT_SWITCHING_ANIMATION_DURATION = 1000; // ms

  static init(widgetId) {
    let widget = new CallbackWidget(widgetId);

    widget._init();

    return widget;
  }

  constructor(widgetId) {
    this.widgetId = widgetId;

    this.$widget = $(`#${widgetId}`);
    this.$form = this.$widget.find('form');
    this.$body = this.$widget.find('.call-back-popup__body');

    this.$closeBtn = this.$widget.find('.popup-close');
    this.$orderBtn = this.$widget.find('button[type="submit"]');
    this.$orderName = this.$widget.find('input#name');
    this.$orderNumber = this.$widget.find('input#number');

    this.animationTimeout = null;

    this.errors = {
      name: false,
      number: false,
    };
    this.$spinner = this.$widget.find('#progress');
  }

  open() {
    window.ymReachGoal('callback-button-metrika');
  }

  close() {
    this.$closeBtn.trigger('click');
  }

  _order() {
    if (this._validate()) {
      this._sendRequest();
    } else {
      this.$orderBtn.addClass('button--disabled');
    }
  }

  _init() {
    this.$orderNumber.each(function () {
      Inputmask('+7 (999) 999-99-99').mask(this);
    });

    this._hideBySchedule();
    this._eventsInit();
    this._selectTimeStop();
    this._selectDropDown();
    this._initContentSwitcher();
  }

  _hideBySchedule() {
    moment.locale('ru');
    const schedule = $('#callback_btn').data('schedule');
    if (!schedule || !schedule.find) {
      $('#callback_btn').hide();
      return;
    }
    const weekday = moment().weekday() == 6 ? 0 : moment().weekday() + 1;
    /** @type {{ day: number, time_from: string, time_to: string, enabled: boolean }} */
    const day = schedule.find((s) => s.day == weekday);
    if (!day) $('#callback_btn').hide();

    const today = moment().format('YYYY-MM-DD');
    const dateFrom = moment(`${today} ${day.time_from} +0300`, 'YYYY-MM-DD HH:mm ZZ');
    const dateTo = moment(`${today} ${day.time_to} +0300`, 'YYYY-MM-DD HH:mm ZZ');

    if (dateFrom.isAfter(moment()) || dateTo.isBefore(moment()) || !day.enabled) {
      $('#callback_btn').hide();
    }
  }

  // Убирает стандартное действие с селекта в выборе времени звонка
  _selectTimeStop() {
    $('.popup .call-wrap .mdc-select select').on('click', function (e) {
      e.preventDefault();
      this.blur();
      window.focus();
    });
  }

  _selectDropDown() {
    $('.call-back .mdc-select').on('click', (e) => {
      $('.mdc-menu-surface').css('z-index', '1100');
    });
  }

  _eventsInit() {
    this.$form.on('submit', (event) => {
      event.preventDefault();

      this._order();
    });

    $(`div[rel="${this.widgetId}"]`).on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.open();
    });

    [this.$orderNumber, this.$orderName].forEach(($input) => {
      $input.on('input', () => this._clearErrors($input));
    });
  }

  _validate() {
    // Валидация поля name
    const nameValue = this.$orderName.val();
    if (!nameValue?.length) {
      this._addError(this.$orderName, 'Обязательно к заполнению');
      this.errors.name = true;
    } else if (this.errors.name) {
      this._clearErrors(this.$orderName);
    }

    // Валидация поля number
    const numberValue = this.$orderNumber.val();
    if (!numberValue?.length) {
      this._addError(this.$orderNumber, 'Обязательно к заполнению');
      this.errors.number = true;
    } else if (!/^\+7 \(9\d{2}\) \d{3}-\d{2}-\d{2}$/.test(numberValue)) {
      this._addError(this.$orderNumber, 'Некорректный формат номера');
      this.errors.number = true;
    } else if (this.errors.number) {
      this._clearErrors(this.$orderNumber);
    }

    return !Object.values(this.errors).some(Boolean);
  }

  _sendRequest() {
    $.ajax({
      type: 'POST',
      url: '/callback_orders',
      data: {
        name: this.$orderName.val(),
        call: {
          name: this.$orderName.val(),
          number: this.$orderNumber.val(),
          callable_id: this.$orderBtn.data().callableId,
          callable_type: this.$orderBtn.data().callableType,
        },
        sales_channel_id: $.cookie('sales_channel_id'),
        website_type: window.website_type,
      },
      beforeSend: () => {
        this._setLoading();
      },
      success: (data) => {
        this._setSuccessPhone();
        this._switchContent('success');
        gtag('event', 'done', {
          event_category: 'Book_callback',
          event_label: `page:${$('h1').text().replace(/\s+/g, ' ')}`,
        });
        window.ymReachGoal('callback-success-metrika');
        this._unsetLoading();
      },
      error: (err) => {
        FunnySadDialog.createSadDialog('Упс, что-то пошло не так', 'Попробуйте еще раз через пару минут.');
        window.ymReachGoal('callback-error-metrika');
        this._unsetLoading();
        this.close();
      },
    });
  }

  _setLoading() {
    this.$orderBtn.prop('disabled', true);
    this.$orderBtn.hide();
    this.$spinner.removeClass('hidden');
  }

  _unsetLoading() {
    this.$orderBtn.prop('disabled', false);
    this.$orderBtn.show();
    this.$spinner.addClass('hidden');
  }

  _addError($input, error = null) {
    const $wrapper = $input.closest('.mtui-text-field__wrapper');
    $wrapper.find('.mtui-text-field__error-label').show();
    $wrapper.addClass('mtui-text-field_error');
    if (error) {
      $wrapper.find('.mtui-text-field__error-label').text(error);
    } else {
      $wrapper.find('.mtui-text-field__error-label').text('Произошла ошибка');
    }
  }

  _clearErrors($input) {
    if (!this.errors[$input[0].id]) return;

    this.errors[$input[0].id] = false;
    $input
      .closest('.mtui-text-field__wrapper')
      .removeClass('mtui-text-field_error')
      .find('.mtui-text-field__error-label')
      .hide()
      .text('');

    if (!Object.values(this.errors).some(Boolean)) {
      this.$orderBtn.removeClass('button--disabled');
    }
  }

  _initContentSwitcher() {
    const callbackWidget = this;
    this.$widget.on('click', '[data-popup-content]', function () {
      const targetContent = $(this).data('popup-content');
      callbackWidget._switchContent(targetContent);
    });
  }

  /**
   * Изменение содержимого модального окна
   * @param {string} targetContent
   * @private
   */
  _switchContent(targetContent) {
    const $currentContent = this.$body.find(`.${CallbackWidget.ACTIVE_CONTENT_CLASS}`);
    const $nextContent = this.$body.find(`.call-back-popup__content--${targetContent}`);
    if (!$nextContent.length) return;

    if (this.animationTimeout) clearTimeout(this.animationTimeout);

    const currentHeight = $currentContent.outerHeight();
    this.$body.css('height', `${currentHeight}px`);

    $currentContent.removeClass(CallbackWidget.ACTIVE_CONTENT_CLASS);
    $nextContent.addClass(CallbackWidget.ACTIVE_CONTENT_CLASS);

    const nextHeight = $nextContent.outerHeight();
    this.$body.css('height', `${nextHeight}px`);

    this.animationTimeout = setTimeout(() => {
      this.$body.css('height', 'auto');
    }, CallbackWidget.CONTENT_SWITCHING_ANIMATION_DURATION);
  }

  _setSuccessPhone() {
    this.$widget
      .find('.success-phone')
      .text(this.$orderNumber.val());
  }
}

export { CallbackWidget };
